// src/utils/measurementUtils.js

/**
 * Converts total inches to feet and remaining inches.
 * @param {number} totalInches - The total inches to convert.
 * @returns {Object} An object containing feet and inches.
 */
export const inchesToFeetAndInches = (totalInches) => {
  if (!isFinite(totalInches) || totalInches < 0) {
    return { feet: 0, inches: 0 };
  }
  
  if (totalInches > Number.MAX_SAFE_INTEGER / 12) {
    return { feet: Math.floor(Number.MAX_SAFE_INTEGER / 12), inches: 0 };
  }
  
  const feet = Math.floor(totalInches / 12);
  const inches = totalInches % 12;
  return { feet, inches };
};

/**
 * Converts feet and inches to total inches.
 * @param {number} feet - The number of feet.
 * @param {number} inches - The number of inches.
 * @returns {number} The total inches.
 */
export const feetAndInchesToInches = (feet, inches) => {
  return feet * 12 + inches;
};


/**
 * Helper to format feet and inches, omitting inches if zero
 * @param {number} feet - The number of feet.
 * @param {number} inches - The number of inches.
 * @returns {string} The formatted string.
 */
export const formatFeetInches = (totalInches) => {
    const { feet, inches } = inchesToFeetAndInches(totalInches);
    return inches === 0 ? `${feet}′` : `${feet}′${inches}″`;
};